import Breadcrumb from '@/components/UI/breadcrumb/Breadcrumb';
import styles from './HouseBreadcrumb.module.scss';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
import { FC } from 'react';
import { suggestionsVillages } from '@/components/houses/productMeta/ProductMeta';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
import { getEnvs } from '@/helpers/getEnvs';
interface HouseBreadcrumbProps {
  data: ProductItemTypes;
  host: string;
}
const domains = {
  green: 'https://www.shab.ir',
  white: 'https://www.shab.travel',
  blue: 'https://www.shab.rentals',
  purple: 'https://www.shabtravel.com'
};
const envColor = getEnvs()?.APP_ENVIRONMENT;
const HouseBreadcrumb: FC<HouseBreadcrumbProps> = ({
  data,
  host
}) => {
  const isWhiteLabel = useIsWhiteLabel();
  const origin = isWhiteLabel ? host : domains[envColor as keyof typeof domains] || 'http://www.shab.ir';
  if (!origin) {
    return <></>;
  }
  const province = data?.location?.province;
  const city = data?.location?.city;
  const village = data?.location?.village;
  const parent = data?.parent;
  const items = [{
    title: 'اجاره ویلا',
    href: origin
  }, {
    title: province,
    href: `${origin}/search/province/${province}`
  }, {
    title: city,
    href: `${origin}/search/city/${city}`
  }];
  if (village && suggestionsVillages.some(item => village?.trim() === item)) {
    items.push({
      title: village,
      href: `${origin}/search/village/${village}`
    });
  }
  if (parent?.id) {
    items.push({
      title: parent?.title,
      href: `${origin}/search?parent_id=${parent.id}`
    });
  }
  if (data?.title) {
    items.push({
      title: data?.title,
      href: `${origin}/houses/show/${data?.id}`
    });
  }
  return <Breadcrumb data={items} className={`${styles['house-breadcrumb']}`} data-sentry-element="Breadcrumb" data-sentry-component="HouseBreadcrumb" data-sentry-source-file="HouseBreadcrumb.tsx" />;
};
export default HouseBreadcrumb;